export default "__VITE_ASSET__e347d4c2__"